import { Box, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import logo from '../assets/logo.svg'
import { useNavigate } from 'react-router-dom'
import { getCategories } from '../Apis/CategoriesApis'

const Footer = () => {
  const navigate = useNavigate()
  const [services, setServices] = React.useState([])

  React.useEffect(() => {
    getCategories().then((data) => {
      if (data && data.status) {
        const fetchedServices = data.categories || data.data;
        if (Array.isArray(fetchedServices)) {
          setServices(fetchedServices)
        }
      }
    })
  }, [])

  const handleServiceClick = (service) => {
    navigate(`/service/${service.id}`, {
      state: {
        categoryId: service.id,
        plans: service.plans,
        options: service.CategoryOptions,
        isOption: service.isOption,
        image: service.image,
        BoxText: service.BoxText,
        name: service.name
      }
    })
  }

  /* Updated Quick Links Structure */
  const quickLinks = [
    { label: 'About Us', slug: 'about-us' },
    { label: 'Services', id: 'services' },
    { label: 'Testimonials', id: 'testimonials' },
    { label: 'Terms Of Use', slug: 'terms-of-use' },
    { label: 'Privacy Policy', slug: 'privacy-policy' },
  ]

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      if (id === 'services' || id === 'testimonials') {
        navigate('/');
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };

  const handleQuickLinkClick = (item) => {
    if (item.id) {
      handleScroll(item.id);
    } else if (item.slug) {
      navigate(`/page/${item.slug}`);
    }
  };

  /* ... servicesLeft ... */

  /* ... servicesRight ... */

  const needHelp = [
    'Contact Us',
    'My Bookings',
    'Reviews',
    'Stories'
  ]

  // Split services for two columns
  const midpoint = Math.ceil(services.length / 2);
  const servicesLeft = services.slice(0, midpoint);
  const servicesRight = services.slice(midpoint);

  return (
    <Box sx={{ backgroundColor: '#3A2F27', color: '#FFFFFF' }}>
      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
        <Grid container spacing={{ xs: 4, md: 6 }}>
          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Box
                component="img"
                src={logo}
                alt="Varahi"
                sx={{ height: 60, width: 'auto' }}
              />
            </Box>

            <Typography
              sx={{
                mt: 2,
                maxWidth: 340,
                fontSize: 12,
                lineHeight: 1.6,
                color: 'rgba(255,255,255,0.7)'
              }}
            >
              Varahi Infra is a trusted name in construction and infrastructure services, offering expert solutions in construction, renovation, demolition, excavation, rock cutting, and painting. We focus on quality workmanship, safety, and timely delivery to meet our clients’ needs with confidence and reliability.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2.5 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              {quickLinks.map((item) => (
                <Typography
                  key={item.label}
                  onClick={() => handleQuickLinkClick(item)}
                  sx={{
                    fontSize: 12,
                    color: 'rgba(255,255,255,0.7)',
                    cursor: 'pointer',
                    width: 'fit-content',
                    '&:hover': { color: '#ff6a00' }
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 2 }}>
              Our Services
            </Typography>
            <Box sx={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                {servicesLeft.map((item) => (
                  <Typography
                    key={item.id || item.name}
                    onClick={() => handleServiceClick(item)}
                    sx={{
                      fontSize: 12,
                      color: 'rgba(255,255,255,0.7)',
                      cursor: 'pointer',
                      width: 'fit-content',
                      '&:hover': { color: '#ff6a00' }
                    }}
                  >
                    {item.name}
                  </Typography>
                ))}
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                {servicesRight.map((item) => (
                  <Typography
                    key={item.id || item.name}
                    onClick={() => handleServiceClick(item)}
                    sx={{
                      fontSize: 12,
                      color: 'rgba(255,255,255,0.7)',
                      cursor: 'pointer',
                      width: 'fit-content',
                      '&:hover': { color: '#ff6a00' }
                    }}
                  >
                    {item.name}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Grid>


        </Grid>
      </Container>

      <Box sx={{ backgroundColor: '#2D241E', py: 2 }}>
        <Container maxWidth="xl">
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: 11,
              color: 'rgba(255,255,255,0.55)'
            }}
          >
            ©2025 Varahi Building Future. All rights reserved
          </Typography>
        </Container>
      </Box>
    </Box>
  )
}

export default Footer;
